import { render, staticRenderFns } from "./FilesTableModal.vue?vue&type=template&id=069f4fae&"
import script from "./FilesTableModal.vue?vue&type=script&lang=ts&"
export * from "./FilesTableModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports